import {
	Button,
	ButtonProps,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from '@mui/material';
import { ReactNode } from 'react';

type Props = {
	title: string;
	description?: ReactNode;
	confirmLabel?: string;
	cancelLabel?: string;
	/** Color of the confirm button; use `error` for destructive actions. */
	confirmColor?: ButtonProps['color'];
	onConfirm: () => void;
	onCancel: () => void;
};

/** Simple "are you sure?" dialog, a replacement for `window.confirm`. */
export default function ConfirmDialog({
	title,
	description,
	confirmLabel = 'OK',
	cancelLabel = 'Cancel',
	confirmColor = 'primary',
	onConfirm,
	onCancel,
}: Props) {
	return (
		<Dialog open onClose={onCancel} fullWidth maxWidth="xs">
			<DialogTitle variant="h2">{title}</DialogTitle>
			{description && (
				<DialogContent>
					<DialogContentText>{description}</DialogContentText>
				</DialogContent>
			)}
			<DialogActions>
				<Button color="secondary" onClick={onCancel}>
					{cancelLabel}
				</Button>
				<Button color={confirmColor} onClick={onConfirm} autoFocus>
					{confirmLabel}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
